module.exports = __webpack_public_path__ + "static/media/start-conversion.82ccae2b.png";